import { DateRangeSelection } from '@shared/components'
import React from 'react'

import { FilterActions, useFiltersContext } from '@/context'

export const ReservationMoveInFilter = () => {
  const [{ reservationMoveInRange }, FilterDispatch] = useFiltersContext()
  const { moveInDate, moveInMax } = reservationMoveInRange

  return (
    <DateRangeSelection
      className="mr-4"
      endDate={moveInMax}
      headerTitle="Move In Date"
      listFilter={true}
      setEndDate={(d?: Date) => {
        if (d) FilterDispatch(FilterActions.clearFilters({ filterName: 'reservations' }))
        FilterDispatch(FilterActions.setReservationMoveInRange({ r: { moveInMax: d } }))
      }}
      setStartDate={(d?: Date) => {
        if (d) FilterDispatch(FilterActions.clearFilters({ filterName: 'reservations' }))
        FilterDispatch(FilterActions.setReservationMoveInRange({ r: { moveInDate: d } }))
      }}
      startDate={moveInDate}
    />
  )
}
